import React from 'react';
// import {Routes, Route} from 'react-router-dom';
import './App.scss';

import HomePage from "./page/HomePage";

function App() {
    // react router 会要求/这种链接格式，会导致路径的异常，先不要了
    return <HomePage/>;
    // return (
    //     <Routes>
    //         <Route path={"/"}>
    //             <Route index element={<HomePage/>}/>
    //         </Route>
    //     </Routes>
    // );
}

export default App;
